/** Shared admin UI copy — buttons, fields, confirms, grid chrome (Translator Master). */

import { ADMIN_PANEL_UI_MAP } from './adminPanelUiMap';

export const UI_EXACT_KEYS: Record<string, string> = {
  ...ADMIN_PANEL_UI_MAP,

  // Prefer stable semantic keys for frequent actions (override catalog ui.* keys)
  Save: 'common.action.save',
  Cancel: 'common.action.cancel',
  Add: 'common.action.add',
  Edit: 'common.action.edit',
  Delete: 'common.action.delete',
  Search: 'common.action.search',
  Submit: 'common.action.submit',
  Back: 'common.action.back',
  Next: 'common.action.next',
  Continue: 'common.action.continue',
  Retry: 'common.action.retry',
  Confirm: 'common.action.confirm',
  Close: 'common.action.close',
  Create: 'common.action.create',
  Update: 'common.action.update',
  Remove: 'common.action.remove',
  Refresh: 'admin.action.refresh',
  Export: 'admin.action.export',
  Import: 'admin.action.import',
  Filter: 'admin.action.filter',
  'Export CSV': 'admin.grid.export_csv',
  CSV: 'admin.grid.csv',
  Approve: 'admin.action.approve',
  Reject: 'admin.action.reject',
  Activate: 'admin.action.activate',
  Deactivate: 'admin.action.deactivate',
  Assign: 'admin.action.assign',
  View: 'admin.action.view',
  Download: 'admin.action.download',
  Upload: 'admin.action.upload',
  Apply: 'admin.action.apply',
  Reset: 'admin.action.reset',
  Clear: 'admin.action.clear',
  'Add New': 'admin.action.add_new',
  'Save Changes': 'admin.action.save_changes',
  Active: 'common.status.active',
  Inactive: 'common.status.inactive',
  Pending: 'common.status.pending',
  Completed: 'common.status.completed',
  Cancelled: 'common.status.cancelled',
  Status: 'admin.label.status',
  Actions: 'admin.label.actions',
  'All statuses': 'admin.grid.all_statuses',
  Name: 'admin.field.name',
  Description: 'admin.field.description',
  Code: 'admin.field.code',
  Email: 'admin.field.email',
  Phone: 'admin.field.phone',
  'S.No': 'admin.grid.serial_no',
  'Search records…': 'admin.grid.search_placeholder',
  'Search records...': 'admin.grid.search_placeholder',
};

export function buildUiBaseStrings(): { common: Record<string, string>; admin: Record<string, string> } {
  const common: Record<string, string> = {};
  const admin: Record<string, string> = {};
  for (const [english, fullKey] of Object.entries(UI_EXACT_KEYS)) {
    if (fullKey.startsWith('common.')) {
      common[fullKey.slice('common.'.length)] = english;
    } else if (fullKey.startsWith('admin.')) {
      admin[fullKey.slice('admin.'.length)] = english;
    }
  }
  return { common, admin };
}

export function resolveUiI18nKey(text: string): string | null {
  const trimmed = text.trim();
  if (!trimmed) return null;
  return UI_EXACT_KEYS[trimmed] || ADMIN_PANEL_UI_MAP[trimmed] || null;
}
